var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
var useGenerateTableColumns = function (_a) {
    //
    var id = _a.id, checked = _a.checked, handleCheck = _a.handleCheck, handleSelectAll = _a.handleSelectAll, _b = _a.customColumns, customColumns = _b === void 0 ? [] : _b, _c = _a.columnPositions, columnPositions = _c === void 0 ? {} : _c, data = _a.data;
    var defaultColumns = [
        {
            columnName: (React.createElement("div", { className: "d-flex align-items-start justify-content-center fund-checkbox common-checkbox-custom small-checkbox ps-2" },
                React.createElement("input", { type: "checkbox", onChange: handleSelectAll, checked: !!checked.length, ref: function (e) {
                        if (!!e) {
                            e.indeterminate = e.checked
                                ? (checked === null || checked === void 0 ? void 0 : checked.length) !== (data === null || data === void 0 ? void 0 : data.length)
                                : false;
                        }
                    } }))),
            keysForCustomFunction: ["trxId"],
            tdCustomFunction: function (keys) { return (React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "common-checkbox-custom small-checkbox ps-2" },
                React.createElement("input", { value: keys === null || keys === void 0 ? void 0 : keys[0], type: "checkbox", name: keys === null || keys === void 0 ? void 0 : keys[0], onChange: handleCheck, checked: checked.findIndex(function (x) { return x.trxId === (keys === null || keys === void 0 ? void 0 : keys[0]); }) > -1 }))); },
            arrowClassName: "justify-content-start",
            columnClassName: "line-4 text-start",
        },
    ];
    var extractColumnKey = function (col) {
        var _a, _b, _c;
        if (typeof col.columnName === "string")
            return col.columnName.trim();
        if (React.isValidElement(col.columnName)) {
            var child = (_a = col.columnName.props) === null || _a === void 0 ? void 0 : _a.children;
            if (typeof child === "string")
                return child.trim();
            if (Array.isArray(child)) {
                return child
                    .map(function (c) { return (typeof c === "string" ? c : ""); })
                    .join("")
                    .trim();
            }
            return (_c = (_b = child === null || child === void 0 ? void 0 : child.toString) === null || _b === void 0 ? void 0 : _b.call(child).trim()) !== null && _c !== void 0 ? _c : "";
        }
        return "";
    };
    var checkboxColumn = defaultColumns.find(function (col) {
        return extractColumnKey(col).toLowerCase().includes("checkbox");
    });
    var actionColumn = defaultColumns.find(function (col) { return extractColumnKey(col) === "Action"; });
    var middleDefaults = defaultColumns.filter(function (col) { return col !== checkboxColumn && col !== actionColumn; });
    var combined = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((checkboxColumn ? [checkboxColumn] : [])), false), __read(middleDefaults), false), __read(customColumns), false), __read((actionColumn ? [actionColumn] : [])), false);
    var sorted = combined.sort(function (a, b) {
        var _a, _b;
        var posA = (_a = columnPositions[extractColumnKey(a)]) !== null && _a !== void 0 ? _a : 100;
        var posB = (_b = columnPositions[extractColumnKey(b)]) !== null && _b !== void 0 ? _b : 100;
        return posA - posB;
    });
    return sorted;
};
export default useGenerateTableColumns;
